// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

//Backend access
import { useQuery } from '@tanstack/react-query';
import { getLiveView, loadToken } from 'services/api/bks';
import PropTypes from "prop-types";
import { useLocation, useNavigate } from 'react-router-dom';

import ClearwayOverlay from '../../../assets/images/clearway_overlay.png';

import { useAuth0 } from "@auth0/auth0-react";
import breakpoints from "assets/theme/base/breakpoints";

function GroupLiveView({ group }) {

  const navigate = useNavigate();
  const location = useLocation();
  loadToken(useAuth0());

  // console.log(navigate)
  // console.log(location)

  // console.log(group);
  var uuid = undefined;

  for (var index in group.devices) {
    if (group.devices[index].connected_state == 'online') {
      uuid = group.devices[index].uuid;
    }
  }

  // console.log(uuid);

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ['getLiveView', uuid],
    queryFn: async () => {
      const data = await getLiveView(uuid);
      return data;
    },
    staleTime: 20 * 1000
  });

  if (isLoading) {
    return ("Loading...");
  }

  if (error) {
    return ("Error! " + error.message);
  }

  const blob = new Blob([data]);
  const url = URL.createObjectURL(blob);

  // var rand = Math.floor(Math.random() * 6);

  // var example;
  // switch (rand) {
  //   case 0:
  //     example = example_0;
  //     break;
  //   case 1:
  //     example = example_1;
  //     break;
  //   case 2:
  //     example = example_2;
  //     break;
  //   case 3:
  //     example = example_3;
  //     break;
  //   case 4:
  //     example = example_4;
  //     break;
  //   case 5:
  //     example = example_5;
  //     break;
  // }

  var liveview_max_width = '1250px';
    if (window.innerWidth < breakpoints.values.lg) {
        liveview_max_width = '475px';
    }
    else if (window.innerWidth < breakpoints.values.xl) {
        liveview_max_width = '540px';
    }
    else if (window.innerWidth < breakpoints.values.xxl) {
        liveview_max_width = '600px';
    }
    else if (window.innerWidth < breakpoints.values.x3l) {
        liveview_max_width = '700px';
    }

  return (
    <SoftBox width="100%" height="100%" sx={{ marginLeft: '16px', marginRight: '16px', marginTop: '16px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start' }}>
      <SoftBox width={'100%'} height={'100%'}>
        <SoftBox width="100%"  >
          <SoftBox width="100%" height="100%" position="relative" borderRadius="lg">
            <SoftBox
              component="img"
              src={url}
              position="absolute"
              width="60%"
              borderRadius="lg"
              sx={{ marginLeft: "36%", marginTop: "4.5%" }}
              zIndex="1"
            />
            <SoftBox
              component="img"
              src={ClearwayOverlay}
              // position="absolute"
              // top={0}
              // left={0}
              position="relative"
              height="100%"
              width="100%"
              borderRadius="lg"
              zIndex="2"
            />
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the GroupLiveView
GroupLiveView.propTypes = {
  group: PropTypes.object
};


export default GroupLiveView;
